import { clsx } from 'clsx';
import { POLISH_MONTHS_SHORT } from '@/components/form/_primitives/date/dateInputUtils.ts';

type CalendarMonthPickerProps = {
  currentMonth: number;
  onPick: (monthIndex: number) => void;
  /** `touch` — kafle pod kciuk, dla arkusza na telefonie. */
  size?: 'default' | 'touch';
};

const CalendarMonthPicker = ({
  currentMonth,
  onPick,
  size = 'default',
}: CalendarMonthPickerProps) => {
  return (
    <div className="grid grid-cols-3 gap-1">
      {POLISH_MONTHS_SHORT.map((label, idx) => (
        <button
          key={idx}
          type="button"
          onClick={() => onPick(idx)}
          className={clsx(
            'rounded-sm text-base-text hover:bg-neutral-100',
            size === 'touch' ? 'px-3 py-3 text-base' : 'px-2 py-1.5 text-sm',
            { 'bg-accent-200 hover:bg-accent-200': idx === currentMonth },
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default CalendarMonthPicker;
